var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sel-opts-wrapper", class: { active: _vm.activeOverlay } },
    [
      _c("div", { ref: "outer", staticClass: "sel-opts-outer" }, [
        _c(
          "div",
          {
            staticClass: "dft-preview ft-bld",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleOpts.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "txt" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.caption) +
                  " : \n                "
              ),
              _c("span", { staticClass: "txt-main" }, [
                _vm._v(_vm._s(_vm.currentOpt)),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "arw" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeOverlay,
                expression: "activeOverlay",
              },
            ],
            staticClass: "expand-outer",
          },
          [
            _c("div", { staticClass: "bg" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "in" },
              _vm._l(_vm.opts, function (opt, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "line",
                    class: { active: _vm.currentOpt === opt },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.optSelection(opt)
                      },
                    },
                  },
                  [_c("span", { staticClass: "name" }, [_vm._v(_vm._s(opt))])]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }